<div *ngIf="!isEnforceCase">
  <mat-form-field class="mat-form-field-override" appearance="outline">
    <mat-select [formControl]="control" panelClass="vendorItemOptionPanel">
      <mat-select-trigger>
        {{control.value?.vendorItemName}}
      </mat-select-trigger>
      <mat-option
              *ngFor="let option of options"
                [value]="option"
              class="mat-option-override"
      >
        <app-select-vendor-item [vendor]="option"></app-select-vendor-item>
      </mat-option>
      <mat-option
      
      >
        <div class="option-button" (click)="newVendorItem()">Create New</div>
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div *ngIf="isEnforceCase">
  <div class="setting_container">
    <div class="input-container seasonal_setting_total">
      <select class="input-container_input input-container_input--thin" [formControl]="enforceCase" (change)="changeEnforceCase($event,this.selectedOption)">
        <option [value]="'up'">Up</option>
        <option [value]="'down'">Down</option>
        <option [value]="'nearest'">Nearest</option>
        <option [value]="'none'">None</option> 
      </select>
    </div>
  </div>
</div>